import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import NavItem from './nav-item';
import { scroll } from './utils';
import { recordStatisticsEvent } from '../../../services/statistics-service';

const Container = styled.div`
  ${props => !props.theme.isLarge && `
    display: none;
  `};
  flex-grow: 2;
  flex-basis: 50%;
  align-items: flex-start;
  display: flex;
`;

const Separator = styled.span`
  &:not(:last-child) {
    color: ${props => props.theme.secondaryColor};
    width: 2px;
    height: 2px;
    margin-right: 13px;
    font: ${props => props.theme.fontWeightHeavy} 14px/100% ${props => props.theme.fontFamilyBody};
    &:before {
      content: ".";
    }
  }
`;

export default function NavMenu({
  navItems, id, statisticable, url,
}) {
  const buildOnClick = section => () => {
    scroll(section);
    window.history.pushState(null, document.title, `${url}#${section}`);

    recordStatisticsEvent({
      event: 'internal_link_click',
      statisticable,
      id,
      clicked_url: section,
      page: url,
    });
  };

  const build = item => {
    const props = {
      title: item.title,
      onClick: buildOnClick(item.sectionName),
    };
    return (
      <React.Fragment key={item.sectionName}>
        <NavItem {...props} />
        <Separator />
      </React.Fragment>
    );
  };

  return (
    <Container>
      {navItems.map(item => build(item))}
    </Container>
  );
}

NavMenu.propTypes = {
  navItems: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    sectionName: PropTypes.string.isRequired,
  })).isRequired,
  id: PropTypes.number.isRequired,
  statisticable: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};
